import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const systemSettingRouter = {
  path: '/system_settings',
  component: Management,
  redirect: '/system_settings/index',
  children: [
    {
      path: 'index',
      component: () => import('@/views/system_settings/Index'),
      meta: {
        auth: Auth.listSystemSettings
      }
    }
  ]
}

export default systemSettingRouter
